// Internal base <svg> wrapper shared by all icons.
// Kept private (underscore prefix) — import concrete icons from `./index.jsx`.
export function Icon({ d, size = 16, stroke = 1.75, fill = 'none', className, style, ...rest }) {
  return (
    <svg
      className={className}
      style={style}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path d={d} />
    </svg>
  );
}
